import axios from 'axios'
import {BUSCAR_EMPRESA} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarEmpresaPorId(codigoEmpresa) {
    const url = `${URL}/empresas/${codigoEmpresa}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_EMPRESA,
            payload: response
        })
    );
}
